import React, { useState } from 'react';
import type { ScheduleBlockDto } from '@/services/schedule';
import { getBrowserTimezone } from '@/utils/datetime';

const DAY_NAMES = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];

type Props = {
  blocks: ScheduleBlockDto[];
  loading: boolean;
  onAdd: (body: {
    dayOfWeek: number;
    startLocal: string;
    endLocal: string;
    label?: string;
  }) => Promise<void>;
  onRemove: (id: string) => Promise<void>;
};

const AvailabilityPanel: React.FC<Props> = ({ blocks, loading, onAdd, onRemove }) => {
  const [dayOfWeek, setDayOfWeek] = useState(1);
  const [startLocal, setStartLocal] = useState('12:00');
  const [endLocal, setEndLocal] = useState('13:00');
  const [label, setLabel] = useState('Lunch break');
  const [saving, setSaving] = useState(false);
  const tz = getBrowserTimezone();

  const handleAdd = async () => {
    setSaving(true);
    try {
      await onAdd({
        dayOfWeek,
        startLocal,
        endLocal,
        label: label.trim() || undefined,
      });
    } finally {
      setSaving(false);
    }
  };

  return (
    <aside className="book-sidepanel">
      <h4>Blocked times</h4>
      <p className="book-sidepanel-desc">
        Slots inside these windows cannot be booked. Times use your timezone ({tz}).
      </p>
      <div className="book-sidepanel-form">
        <label>
          Day
          <select value={dayOfWeek} onChange={(e) => setDayOfWeek(Number(e.target.value))}>
            {DAY_NAMES.map((name, i) => (
              <option key={name} value={i}>
                {name}
              </option>
            ))}
          </select>
        </label>
        <label>
          From
          <input type="time" value={startLocal} onChange={(e) => setStartLocal(e.target.value)} />
        </label>
        <label>
          To
          <input type="time" value={endLocal} onChange={(e) => setEndLocal(e.target.value)} />
        </label>
        <label>
          Label
          <input value={label} onChange={(e) => setLabel(e.target.value)} placeholder="Optional" />
        </label>
        <button type="button" className="studio-send" disabled={saving} onClick={() => void handleAdd()}>
          {saving ? 'Adding…' : 'Add block'}
        </button>
      </div>
      {loading ? (
        <p className="promo-empty">Loading…</p>
      ) : blocks.length === 0 ? (
        <p className="promo-empty">No blocks yet — all slots open by default.</p>
      ) : (
        <ul className="book-block-list">
          {blocks.map((b) => (
            <li key={b.id}>
              <div>
                <strong>{DAY_NAMES[b.dayOfWeek]}</strong>
                <span>
                  {b.startLocal} – {b.endLocal}
                </span>
                {b.label && <em>{b.label}</em>}
              </div>
              <button type="button" className="pill-btn" onClick={() => void onRemove(b.id)}>
                Remove
              </button>
            </li>
          ))}
        </ul>
      )}
    </aside>
  );
};

export default AvailabilityPanel;
